import { getRequest } from '../../../../../services/httpService';
import { getPatientApiUrlById } from '../../../../../services/urls';

interface AdditionalInfo {
    id: number;
    additional_details: string;
    alternate_mobile_number?: string | null;
    alternate_mobile_number_country_code?: string;
    company_name?: string;
    consulted_with_family?: boolean;
    education?: string;
    ethnicity?: string;
    identity_no?: string;
    identity_proof?: string | null;
    identity_type?: string;
    marital_status?: string | null;
    nationality?: string;
    no_of_existing_children_count?: number | null;
    no_of_years_of_marriage?: number | null;
    occupation?: string;
    patient: number;
    preferred_language?: string;
    previous_doctor_name?: string | null;
    previous_hospital_name?: string | null;
    reason_for_visit: string;
    reference_details?: string;
    referral_doctor?: string | null;
    remark?: string;
    source_of_reference?: string;
    special_registration?: boolean;
    visited_doctor_before?: boolean;
    visited_doctor_for_pregnancy_before?: boolean;
    acne?: boolean | null;
    acne_age?: number | null;
    age_used_dental?: number | null;
    bmi?: number | null;
    body_type?: string | null;
    dental_device?: string | null;
    dental_device_reason?: string | null;
    describe_difficulty?: string | null;
    dimples?: boolean | null;
    donated_egg_or_sperm?: boolean;
    donation_count_cycle?: number | null;
    donor_program_name?: string | null;
    ever_applied_screened?: boolean;
    eye_color?: string | null;
    freckles?: boolean | null;
    hair_color_as_adult?: string | null;
    hair_color_as_child?: string | null;
    hair_fullness?: string | null;
    hair_shade?: string | null;
    hair_texture?: string | null;
    hair_type?: string | null;
    handedness?: string | null;
    hearing_difficulties?: boolean;
    height?: number | null;
    moles?: boolean | null;
    skin_condition?: string | null;
    skin_tone?: string | null;
    treatment_required?: boolean;
    vision?: string | null;
    vision_correction?: string | null;
    vision_correction_age?: number | null;
    weight?: number | null;
    height_unit?: string;
    weight_unit?: string;
  }
  
  interface Address {
    id: number;
    address_type: string;
    area?: string;
    city: string;
    country: string;
    landmark?: string;
    line_1: string;
    line_2?: string;
    pincode: string;
    state: string;
    street?: string;
    user: number;
  }
  
  interface Partner {
    id: number;
    first_name: string;
    last_name: string;
    middle_name?: string;
    date_of_birth: string;
    blood_group: string;
    gender: string;
    medical_record_no: string;
    mobile_number: string;
    mobile_number_country_code: string;
    patient_type: string;
    photo?: string;
    prefix: string;
    delink_reason?: string | null;
    delink_remark?: string | null;
    additional_info: AdditionalInfo;
    addresses: Address[];
    alternate_email?: string;
    updated_on: string;
  }
  
export interface PatientData {
    id: number;
    age: number;
    first_name: string;
    last_name: string;
    middle_name?: string;
    date_of_birth: string;
    blood_group: string;
    gender: string;
    medical_record_no: string;
    mobile_number: string;
    mobile_number_country_code: string;
    patient_type: string;
    photo?: string;
    prefix: string;
    additional_info: AdditionalInfo;
    addresses: Address[];
    partner: Partner;
    alternate_email?: string;
    updated_on: string;
    created_on: string;
    clinic: number;
  }
  
  
export function getPatientInfo(id: string, query?:string): Promise<PatientData> {
  return getRequest(getPatientApiUrlById(id, query), { responseType: 'json' });
}
  
export interface Patient {
  id: number;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  gender: string;
}

interface LaboratoryTest {
  id: number;
  identifier: number;
  name: string;
  icon_url: string;
  unit: string;
  categories: {
    id: number;
    name: string;
    icon_url: string;
    gender: string;
    test_ids: number[];
  }[];
}

export interface Investigation {
  id: number;
  patient: Patient;
  laboratory_test: LaboratoryTest;
  remark: string | null;
  created_on: string;
  doctor_first_name: string;
  doctor_last_name: string;
  results: string | null;
  range: string | null;
}

export interface InvestigationReportProps {
  investigations: Investigation[];
}

// Meta interface for Pagination Information
export interface Meta {
  limit: number;
  next: string | null;
  offset: number;
  previous: string | null;
  total_count: number;
}


export interface investigatioResponse<T> {
  meta: Meta;
  objects: T[];
}

// Make sure to import any required helper functions such as getRequest, getPatientApiUrlById, etc.
export function getinvestigationInfo(query?: string): Promise<investigatioResponse<Investigation>> {
  const url = `/investigation/?${query}`;
  return getRequest(url, { responseType: 'json' });
}


export interface Diagnosis {
  id: number;
  diagnosis_code: string;
  diagnosis_name: string;
  diagnosis_type: string;
  doctor_name: string;
  notes: string | null;
  created_on: string;
  diagnosis_type_label?: string | null;
}
export interface DiagnosisReportProps {
  diagnoses: Diagnosis[];
  // patient: Patient;
}

export interface DiagnosisResponse<T> {
  meta: Meta;
  objects: T[];
}

export function getDiagnosisInfo(query?: string): Promise<DiagnosisResponse<Diagnosis>> {
  const url = `/patient-diagnosis/?${query}`;
  return getRequest(url, { responseType: 'json' });
}
